// Google Consent Mode v2 wiring. Two parts:
//  1. consentDefaultSnippet — an inline <head> script (injected via gatsby-ssr)
//     that sets ALL consent signals to "denied" for every visitor BEFORE GTM
//     loads, then immediately upgrades to "granted" for a returning visitor whose
//     stored choice is already "granted". This lets GTM load for everyone — GA4
//     sends cookieless, non-identifying pings while denied.
//  2. updateConsentMode(granted) — called at runtime from the banner's accept /
//     decline handlers (and reopen → reverse) to flip the signals live.

import { CONSENT_COOKIE, CONSENT_GRANTED } from "./consent-cookie"

// The v2 signal set. functionality_/personalization_/security_storage default to
// "granted" in Consent Mode and aren't needed for GA4/Ads, so we leave them unset.
const GRANTED = {
  ad_storage: "granted",
  ad_user_data: "granted",
  ad_personalization: "granted",
  analytics_storage: "granted",
}
const DENIED = {
  ad_storage: "denied",
  ad_user_data: "denied",
  ad_personalization: "denied",
  analytics_storage: "denied",
}

// Inline script for the <head>. Runs before GTM (which loads post-hydration).
// `wait_for_update` gives the banner a moment to send an update before tags fire.
// The returning-visitor check reads the first-party consent cookie so a prior
// "granted" is honored immediately, without waiting for React to hydrate.
export const consentDefaultSnippet = `
window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('consent', 'default', {
  'ad_storage': 'denied',
  'ad_user_data': 'denied',
  'ad_personalization': 'denied',
  'analytics_storage': 'denied',
  'wait_for_update': 500
});
try {
  if (document.cookie.split('; ').indexOf('${CONSENT_COOKIE}=${CONSENT_GRANTED}') !== -1) {
    gtag('consent', 'update', {
      'ad_storage': 'granted',
      'ad_user_data': 'granted',
      'ad_personalization': 'granted',
      'analytics_storage': 'granted'
    });
  }
} catch (e) {}
`

export const updateConsentMode = (granted) => {
  if (typeof window === "undefined") return
  window.dataLayer = window.dataLayer || []
  // Mirror gtag's arguments-object push (Consent Mode reads the arguments object,
  // not a plain array), independent of the head snippet's gtag being in scope.
  function gtag() {
    window.dataLayer.push(arguments)
  }
  gtag("consent", "update", granted ? GRANTED : DENIED)
}
